import React from 'react';
import { flushSync } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { StepProps } from '../MultiStepModal';
import { useModal } from '../../../contexts/ModalContext';

export default function CertificateCreateModeStep({ onDataChange, onNext }: StepProps) {
  const navigate = useNavigate();
  const { closeModal } = useModal();

  return (
    <div className="step-form">
      <div className="step-header">
        <h3 className="step-form-title">How would you like to complete this certificate?</h3>
        <p className="step-form-subtitle">
          Fill it in the office yourself, or schedule an engineer with the right PDF checklist (e.g. CP17 breakdown).
        </p>
      </div>

      <div className="step-form-content">
        <div className="grid grid-cols-1 gap-3">
          <button
            type="button"
            className="rounded-xl border border-[#E6E6E4] bg-white p-4 text-left hover:border-[#2563eb]/40 hover:bg-[#eff6ff]/50 transition-colors"
            onClick={() => {
              flushSync(() => {
                onDataChange({ certificateFlow: 'request' });
              });
              onNext();
            }}
          >
            <div className="text-sm font-semibold text-[#181818]">Request an engineer</div>
            <div className="mt-1 text-xs text-[#686E6C]">
              Pick your approved PDF template, add site &amp; job details, then assign who completes it on site.
            </div>
          </button>

          <button
            type="button"
            className="rounded-xl border border-[#E6E6E4] bg-white p-4 text-left hover:border-[#181818]/20 hover:bg-[#FAFAF9] transition-colors"
            onClick={() => {
              flushSync(() => {
                onDataChange({ certificateFlow: 'self' });
              });
              closeModal();
              navigate('/dashboard/certificates/new');
            }}
          >
            <div className="text-sm font-semibold text-[#181818]">Create it yourself now</div>
            <div className="mt-1 text-xs text-[#686E6C]">
              Opens the full-screen wizard to fill the certificate in the browser (same templates your engineers use).
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
